import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button, Paper, Stack, TextField, Typography } from "@mui/material";
import usePrimaryColor from "../../hooks/usePrimaryColor";
import { SPECIES_MASTER } from "../../enums/QueryKeys";
import usePut from "../../hooks/usePut";
import { useQueryClient } from "@tanstack/react-query";

export default function MultiLangForm({
  object,
  postUrl,
  btnMsg,
  translationTarget = "translations",
  maxLength = 255,
  mutationKey = SPECIES_MASTER,
  invalidationKeys = [],
}) {
  const { t, i18n } = useTranslation();
  const languages = Object.keys(i18n.options.resources);
  const queryClient = useQueryClient();
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const edit = usePut(postUrl, mutationKey, invalidationKeys);

  const onSubmit = async (data) => {
    const submitData = {
      ...object,
      [translationTarget]: {
        ...object[translationTarget],
        ...data,
      },
    };
    const res = await edit.submitCallback(submitData);
    if (res) {
      reset(data);
      queryClient.invalidateQueries(mutationKey);
    }
  };

  const translations = object?.[translationTarget] ?? "";
  const color = usePrimaryColor();

  if (languages?.length > 0) {
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        {languages.map((lang, index) => (
          <Stack
            key={index}
            direction={"row"}
            width={"100%"}
            spacing={2}
            alignItems={"center"}
            mt={2}
          >
            <Paper
              sx={{
                p: 1,
                border: `2px solid ${color}`,
              }}
            >
              <Typography>{String(lang).toUpperCase()}</Typography>
            </Paper>
            <Controller
              name={`${lang}`}
              defaultValue={translations[lang] ?? ""}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  inputProps={{ maxLength: maxLength }}
                  label={t("EnterATranslation")}
                  fullWidth
                />
              )}
            />
          </Stack>
        ))}
        <Stack direction={"row"} alignItems={"center"} spacing={2} mt={2}>
          <Button variant="contained" color="info" sx={{ mt: 2 }} type="submit">
            {t(btnMsg)}
          </Button>
        </Stack>
      </form>
    );
  }

  return null;
}
